import axios from "axios";
import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router";
import leftArrow from "../../../assets/images/left-arrow.svg";
import filterArrow from "../../../assets/images/search/filter-arrow.svg";
import * as API_URL from "../../../constants/ApiUrl";
import {GET_FAQ_DETAIL_QUERY} from "../../../constants/query/FaqList.query";
import Popup from "../../common/popup/Popup";
import {PopupProps} from "../../common/popup/Popup.props";
import {CategoryInfo} from "../constant/Category.type";
import {FaqDto} from "../dto/Faq.dto";
import "./style.css";
import {FAQ} from "../../../constants/Routes";

export default function Detail() {
    const [isFilterOpen, setFilterOpen] = useState<boolean>(false);
    const [currentCategory, setCategory] = useState<number>(0);
    const [detail, setDetail] = useState<FaqDto>(new FaqDto());
    const [popupProps, setPopupProps] = useState<PopupProps | null>(null);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (location.state.seq !== 0) {
            getFAQs();
        }
    }, []);

    const getFAQs = () => {
        axios.post(API_URL.GRAPHQL, {
            query: GET_FAQ_DETAIL_QUERY(location.state.seq)
        }).then(response => {
            setDetail(response.data.data.getFAQs.items[0]);
            setCategory(response.data.data.getFAQs.items[0].category)
        });
    };

    const onFilterBoxClick = () => {
        setFilterOpen(!isFilterOpen);
    }

    const onPickCategory = (filter: number) => {
        setFilterOpen(false);
        setCategory(filter);
    }

    const onFAQChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const {name, value} = event.target;
        setDetail({...detail, [name]: value});
    }

    const onSignUpButtonClick = () => {
        if (detail.title.replace(/\s/g, "") === ""
            || detail.content.replace(/\s/g, "") === ""
            || detail.title.length > 500
        ) {
            setPopupProps({
                subject: location.state.seq === 0 ? "FAQ 등록" : "FAQ 수정",
                message1: detail.title.length > 500 ? "제목은 500자 이내로 입력해주세요" : "제목 및 내용을 입력해 주세요",
                message2: null,
                buttonName: "확인",
                onConfirm: () => setPopupProps(null),
                useCloseButton: false,
                onClose: () => setPopupProps(null)
            });

            return;
        }

        const faq: FaqDto = new FaqDto();
        faq.seq = location.state.seq;
        faq.category = currentCategory;
        faq.title = detail.title;
        faq.content = detail.content;

        if (faq.seq === 0) {
            axios.post(API_URL.FAQ, faq).then(() => {
                navigate(FAQ);
            });
        } else {
            axios.put(API_URL.FAQ, faq).then(() => {
                navigate(FAQ);
            });
        }
    }

    return (
        <>
            <div className="FAQ-detail">
                <main className="wrapper">
                    <div className="FAQ-detail-body">
                        <div className="FAQ-detail-title">
                            <div className="left">
                                <button className="arrow">
                                    <img src={leftArrow} alt="arrow" onClick={() => navigate(FAQ)}/>
                                </button>
                                <div className="text">
                                    FAQ 상세
                                </div>
                            </div>
                            <div className="right">
                                <button className="SignUp-button" onClick={onSignUpButtonClick}>
                                    {location.state.seq === 0 ? "등록하기" : "수정하기"}
                                </button>
                            </div>
                        </div>
                        <div className="FAQ-detail-box">
                            <div className="FAQ-box-top">
                                <div className="FAQ-catagory">
                                    <div className="title">
                                        분류
                                    </div>
                                    <div className="faq-category-relative" onClick={onFilterBoxClick}>
                                        <div className={`faq-category-wrapper ${isFilterOpen ? "open-category" : ""}`} data-testid={"category-wrapper"}>
                                            <button className="category-box" data-testid={"category-box-header"}>
                                                <div className="text">
                                                    {CategoryInfo.ordinalToName(currentCategory)}
                                                </div>
                                                <img src={filterArrow} alt="arrow"/>
                                            </button>
                                            {
                                                CategoryInfo.categoryTypes.map((category, index) => {
                                                    if (currentCategory !== index) {
                                                        return (
                                                            <button className="category-box" key={index} onClick={() => onPickCategory(index)} data-testid={"category-box"}>
                                                                <div className="text">{category}</div>
                                                            </button>
                                                        )
                                                    }
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="FAQ-title">
                                    <div className="title">
                                        제목
                                    </div>
                                    <div className="title-box">
                                        <input placeholder="제목을 입력해주세요" name={"title"} value={detail.title} onChange={onFAQChange}/>
                                    </div>
                                </div>
                            </div>

                            <div className="FAQ-detail-write">
                                <div className="FAQ-write">
                                    <div className="title">
                                        내용
                                    </div>

                                    <div className="write-box">
                                        <textarea placeholder="내용을 입력해주세요" name={"content"} value={detail.content} onChange={onFAQChange}></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
            {
                popupProps && (
                    <Popup data={popupProps}></Popup>
                )
            }
        </>
    )
}